<template>
  <div ref="editorContainer" class="code-editor"></div>
</template>

<script>
import { EditorView, basicSetup } from 'codemirror';
import { html } from '@codemirror/lang-html';

export default {
  name: 'CodeMirror',
  props: {
    modelValue: {
      type: String,
      default: '',
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      editor: null
    };
  },
  watch: {
    modelValue(newVal) {
      // Prevent unnecessary updates
      if (this.editor && this.editor.state.doc.toString() !== newVal) {
        this.editor.dispatch({
          changes: {
            from: 0,
            to: this.editor.state.doc.length,
            insert: newVal,
          }
        });
      }
    }
  },
  mounted() {
    this.editor = new EditorView({
      doc: this.modelValue,
      extensions: [
        basicSetup,
        html(),
        EditorView.updateListener.of((update) => {
          if (update.docChanged) {
            const value = this.editor.state.doc.toString();
            this.$emit('update:modelValue', value);
          }
        }),
      ],
      parent: this.$refs.editorContainer,
    });
  },
  beforeUnmount() {
    if (this.editor) this.editor.destroy();
  }
};
</script>

<style>
.code-editor {
  border: 1px solid #ccc;
  font-family: monospace;
  height: 300px;
}
</style>
